import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getAnalytics, isSupported } from 'firebase/analytics'
import { firebaseConfig } from './config'

export const app = initializeApp(firebaseConfig)

// isSupported() guards against environments that block Analytics (privacy extensions, etc.)
export const analytics = isSupported().then((yes) => (yes ? getAnalytics(app) : null))

export const auth = getAuth(app)

export const storage = getStorage(app)

// persistentLocalCache with persistentMultipleTabManager replaces the
// deprecated enableIndexedDbPersistence() — handles multi-tab gracefully
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
})
